import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import { Observable, of, EMPTY, mergeMap, take } from 'rxjs';
import { PubSearchService } from '../services/pub-search.service';
import { AdamsDocModel } from '../models/adams-doc-model';
import { MessageService } from 'primeng/api';
import { SearchResultsModel } from '../models/search-results-model';
import { DocItemSearchModel } from '../models/doc-item-search-model';

@Injectable({
  providedIn: 'root'
})
export class PropertyViewResolverService implements Resolve<AdamsDocModel> {
  constructor(private searchSvc: PubSearchService, private messageSvc: MessageService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const qData = route.paramMap.get('id');
    // console.log('qdata: ' + qData);

    if (qData) {
      
      let formData: DocItemSearchModel = JSON.parse(decodeURIComponent(qData));
      // console.log('item data: ' + JSON.stringify(formData));

      return this.searchSvc.getDocDetails(formData).pipe(
        take(1),
        mergeMap((e: SearchResultsModel) => {
          if (e) {
            return of(e.document);
          } else {
            return EMPTY;
          }
        })
      );
    }
    else {
      this.messageSvc.add({ summary: 'There was an error retrieving results!', severity: "error", detail: "No Query was sent!" })
      return EMPTY;
    }
  }
}
